import { z } from 'zod';
/** Body of `POST /api/push/subscriptions` (Web Push subscribe). */
export const PushSubscribeRequest = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
});
/** Body of `DELETE /api/push/subscriptions`. */
export const PushUnsubscribeRequest = z.object({
    endpoint: z.string().url(),
});
export const PushPublicKeyResponse = z.object({
    vapidPublicKey: z.string().min(1),
});
export const PushSubscribeResponse = z.object({
    id: z.guid(),
    /** True on first insert for this endpoint, false when it already existed. */
    created: z.boolean(),
});
/** One row of `GET /api/push/subscriptions` — mirrors the repo's PushSubscription. */
export const PushSubscriptionDTO = z.object({
    id: z.guid(),
    adminId: z.guid(),
    endpoint: z.string().url(),
    p256dh: z.string(),
    auth: z.string(),
    userAgent: z.string().nullable(),
    createdAt: z.string(),
    lastSuccessAt: z.string().nullable(),
    lastError: z.string().nullable(),
    lastErrorAt: z.string().nullable(),
});
export const ListPushSubscriptionsResponse = z.object({
    items: z.array(PushSubscriptionDTO),
});
//# sourceMappingURL=push.js.map